import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';

const styles = (theme: Theme) => ({
  stickyRoot: {
    display: 'flex',
    flexDirection: 'column' as const,
    [theme.breakpoints.down('md')]: {
      flex: 1,
      minHeight: 0,
    },
  },
  stickyForm: {
    display: 'flex',
    flexDirection: 'column' as const,
    [theme.breakpoints.down('md')]: {
      flex: 1,
      minHeight: 0,
    },
  },
  stickyFormBody: {
    display: 'flex',
    flexDirection: 'column' as const,
    [theme.breakpoints.down('md')]: {
      flex: 1,
      minHeight: 0,
    },
  },
  stickyActionsFooter: {
    flexShrink: 0,
    width: '100%',
    [theme.breakpoints.down('md')]: {
      marginTop: 'auto',
    },
  },
  // Paper root class for Select's Menu dropdown
  dropdownPaper: {
    boxShadow: theme.shadows[8] + ' !important',
    marginTop: theme.spacing(1),
  },
});

export default makeStyles()(styles);
